module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"sort":"Сортировка","filter":"Фильтр","results_not_found":"Результаты не найдены","search":"Идёт поиск...","empty_all":"Нет материалов","empty_start":"По запросу","empty_end":"ничего не найдено.","show_more":"Показать ещё {perPage}","perfumes_one":"аромат","perfumes_few":"аромата","perfumes_many":"ароматов","all":"Все"}}')
  delete Component.options._Ctor
}
